import { createContext, type ReactNode, useContext, useState } from 'react';
import type { PasswordSubmission } from './types';

interface PublishedViewAuthContextType {
  submission: PasswordSubmission | undefined;
  submit: (password: string) => Promise<void>;
}

const PublishedViewAuthContext = createContext<PublishedViewAuthContextType | undefined>(undefined);

export function PublishedViewAuthProvider({ children }: { children: ReactNode }) {
  const [submission, setSubmission] = useState<PasswordSubmission>();

  const submit = async (password: string): Promise<void> => {
    setSubmission({ password, submittedAt: Date.now() });
  };

  return (
    <PublishedViewAuthContext.Provider value={{ submission, submit }}>
      {children}
    </PublishedViewAuthContext.Provider>
  );
}

export function usePublishedViewAuth(): PublishedViewAuthContextType {
  const ctx = useContext(PublishedViewAuthContext);
  if (!ctx) {
    throw new Error('usePublishedViewAuth must be used within PublishedViewAuthProvider');
  }
  return ctx;
}
